
import React, { Component } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
} from "reactstrap";
import { NavLink as RRNavLink, Navigate, Route, Routes, Router } from "react-router-dom";
import { ProtectedRoute } from "../common/protectedRoute";
import Formularios from "./Formularios";
import InscricoesBolsista from "./InscricoesBolsista";
import Projetos from "./Projetos";
import Usuarios from "./Usuarios";
import UsuarioForm from "./UsuarioForm";
import ProjetoForm from "./ProjetoForm";
import AuthService from "../services/authService";
import FormularioBolsista from "./FormularioBolsista";
import { FormEditView } from "./FormEdit";
import { ConfigurationsView } from "./Configurations";

class Gerenciamento extends Component {
  state = {};

  logoutfunc = async () => {
    await AuthService.logout();
    // @ts-ignore
    window.location = "/";
  };


  componentDidMount() {
    console.log("Gerenciamento, didMount", "Bolsista? ", AuthService.isInRole(["Bolsista"]));
  }


  render() {

    const user = AuthService.getCurrentUser();

    return (


      AuthService.isValid() ?
        <>
          <header className="background-home"></header>
          <div className="app flex-row align-items-center">
            <div className="mt-2 mx-5">
              <Row className="justify-content-center">

                <Col md="12">

                  <Card className="bg-success">
                    <CardHeader className="container-fluid">
                      <ul className="nav nav-tabs card-header-tabs">
                          <NavItem>
                            <NavLink to="/gerenciamento/formularios" className="menuPrincipal" tag={RRNavLink}> Formulários </NavLink>
                          </NavItem>
                          {AuthService.isInRole(["FAEPI"]) && (
                              <NavItem>
                                <NavLink to="/gerenciamento/projetos" className="menuPrincipal" tag={RRNavLink}> Projetos </NavLink>
                              </NavItem>
                            )}
                          {AuthService.isInRole(["FAEPI"]) && (
                              <NavItem>
                                <NavLink to="/gerenciamento/usuarios" className="menuPrincipal" tag={RRNavLink} >
                                  Usuários
                                </NavLink>
                              </NavItem>
                            )}
                           {AuthService.isInRole(["FAEPI"]) && (
                              <NavItem>
                                <NavLink to="/gerenciamento/configuracoes" className="menuPrincipal" tag={RRNavLink}> Configurações </NavLink>
                              </NavItem>
                            )} 

                              <NavItem className="text-right col" style={{ color:"white" }}>
                              Gerenciamento - {user.Role} | Bem vindo {user.sub} - {user.FullName}!   <button onClick={() => this.logoutfunc()} type="button" className="btn btn-dark"><i className="fa fa-sign-out" aria-hidden="true"></i> Sair</button>   
                              </NavItem>
                      </ul>
                     
                    </CardHeader>
                    <CardBody className="bg-gray-200" >

                      <Row>

                        {/* Master */}
                        

                        {/*  Detail */}
                        <Col md="12" className="flex" style={{ minHeight: "69vh", maxHeight: "69vh", overflow: "hidden" }}>
                          <Routes>

                            {AuthService.isInRole(["Bolsista"]) &&
                              <Route path="/novo" element={<FormEditView />}></Route>
                            }

                            <Route path="/formularios">
                              <Route path=":id" element={<FormEditView />} />
                              {AuthService.isInRole(["Bolsista"]) ?
                                <Route path="" element={<InscricoesBolsista />} />
                                :
                                <Route path="" element={<Formularios />} />
                              }
                            </Route>

                            <Route path="/projetos" >
                              <Route path=":id" element={<ProjetoForm />} />
                              <Route path="" element={<Projetos />} />
                            </Route>

                            <Route path="/usuarios" >
                              <Route path=":id" element={<UsuarioForm />} />
                              <Route path="" element={<Usuarios />} />
                            </Route>

                            {AuthService.isInRole(["FAEPI"]) &&
                              <Route path="/configuracoes" element={<ConfigurationsView />}></Route>
                            }


                            {/* Default / Catch All*/}
                            <Route path="*" element={<Navigate to="/gerenciamento/formularios" />} />

                            {/* 
                           

                            <ProtectedRoute
                              exact
                              path="/gerenciamento/projetos"
                              name="Gerenciamento Projetos"
                              roles={["FAEPI"]}
                              render={(props) => <Projetos {...props} />}
                            ></ProtectedRoute>

                            
                            <ProtectedRoute
                              exact
                              path="/gerenciamento/projetos/:id"
                              name="Formulário de Projeto"
                              roles={["FAEPI"]}
                              render={(props) => <ProjetoForm {...props} />}
                            ></ProtectedRoute>

                            <ProtectedRoute
                              exact
                              path="/gerenciamento/usuarios"
                              name="Gerenciamento Usuários"
                              roles={["FAEPI"]}
                              render={(props) => <Usuarios {...props} />}
                            ></ProtectedRoute>

                            <ProtectedRoute
                              exact
                              path="/gerenciamento/usuarios/:id"
                              name="Formulário de Usuário"
                              roles={["FAEPI"]}
                              render={(props) => <UsuarioForm {...props} />}
                            ></ProtectedRoute> */}


                          </Routes>
                        </Col>


                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          </div>
        </>
        :
        <Routes>
          <Route path="*" element={<Navigate to={`/login${window.location.search}`} />} />
        </Routes>





    );
  }
}

export default Gerenciamento;
